
import { saveExcel } from '@progress/kendo-vue-excel-export';

export default {

install(Vue, options) {
  
  Vue.prototype.saveExcel = function (exportOptions) {

  	//change data options, to format date
  	//change header color
  //	exportOptions.headerPaddingCellOptions={color:"#FFFFFF"};
    exportOptions.columns=exportOptions.columns.filter(i=>!i.hidden&&!i.webonly);
  if(Array.isArray(exportOptions.columns)){
  	exportOptions.columns=exportOptions.columns.map(i=>{
  	i.headerCellOptions={"background":"#397289"};
  		return i;
  	});
	}

  	saveExcel(exportOptions);
  	
  	}
  }
}
  

/*	if(i.type=="date"){
  	if(Array.isArray(exportOptions.data)){


		 	exportOptions.data=exportOptions.data.map(d=>{
		 		d[i.field]=kendo.parseDate(d[i.field]);
		 		return d;

		 	});
  		}
  	}
  */
  

